<template>
  <div id="appNavbar">
    <ServerError v-if="ServerError" />
    <v-app-bar color="#33024A" dark dense elevation="0"></v-app-bar>
    <v-app-bar
      class="hidden-md-and-down"
      color="#33024A"
      light
      dense
      elevation="0"
    >
      <v-spacer></v-spacer>

      <v-layout
        md8
        lg8
        v-if="(isTypeSeller == 'true' || isTypeSeller == true) && appLogin"
        wrap
        justify-center
      >
        <v-flex justify-center>
          <v-btn
            :disabled="disableNav"
            dark
            text
            :ripple="false"
            color="white"
            style="font-family::opensansbold;font-size:12px"
            class="nav_item text-capitalize"
            to="/myProducts"
          >
            <v-img
              src="./../../assets/images/productIcon.png"
              contain
              style="padding-right: 15px"
              height="23px"
            ></v-img
            >&nbsp;YourProducts
          </v-btn>
        </v-flex>
        <v-flex justify-center>
          <v-btn
            :disabled="disableNav"
            dark
            text
            :ripple="false"
            color="white"
            style="font-family::opensansbold;font-size:12px"
            class="nav_item text-capitalize"
          >
            <v-img
              src="./../../assets/images/ordersIcon.png"
              contain
              style="padding-right: 15px"
              height="22px"
            ></v-img
            >&nbsp; Orders
          </v-btn>
        </v-flex>
        <v-flex justify-center>
          <v-btn
            :disabled="disableNav"
            dark
            text
            :ripple="false"
            color="white"
            style="font-family::opensansbold;font-size:12px"
            class="nav_item text-capitalize"
          >
            <v-img
              src="./../../assets/images/accountsIcon.png"
              contain
              style="padding-right: 15px"
              height="23px"
            ></v-img
            >&nbsp;Accounts
          </v-btn>
        </v-flex>
        <v-flex justify-center>
          <v-btn
            :disabled="disableNav"
            dark
            text
            :ripple="false"
            color="white"
            style="font-family::opensansbold;font-size:12px"
            class="nav_item text-capitalize"
          >
            <v-img
              src="./../../assets/images/messagesIcon.png"
              contain
              style="padding-right: 15px"
              height="16px"
            ></v-img
            >&nbsp; Messages
          </v-btn>
        </v-flex>
        <v-flex justify-center>
          <v-btn
            :disabled="disableNav"
            dark
            text
            :ripple="false"
            color="white"
            style="font-family::opensansbold;font-size:12px"
            class="nav_item text-capitalize"
          >
            <v-img
              src="./../../assets/images/bookmarksIcon.png"
              contain
              style="padding-right: 15px"
              height="18px"
            ></v-img
            >&nbsp; Bookmarks
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-else wrap justify-center>
        <v-flex v-for="(categories, i) in navItems" :key="i">
          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                block
                tile
                dark
                text
                v-on="on"
                class="select_Menu"
                :to="'/Category/' + categories._id + '/' + categories.name"
              >
                <span
                  style="font-family: opensansregular; font-size: 11px"
                  class="text-capitalize"
                >
                  {{ categories.name }}
                  <v-icon style="font-size: 12px">mdi-chevron-down</v-icon>
                </span>
              </v-btn>
            </template>
            <v-list
              color="#33024A"
              dark
              v-if="categories.subcategory.length > 0"
              v-model="categoryid"
              dense
              tile
            >
              <v-list-item
                class="text-left"
                v-for="(item, i) in categories.subcategory"
                :key="i"
                :to="'/SubCategory/' + item._id + '/' + item.name"
              >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>
<script>
import axios from "axios";
import store from "../../store";

export default {
  data() {
    return {
      ServerError: false,
      menu: false,
      categoryid: null,
      navItems: [],
      disableNav: false,
      //usertype:localStorage.getItem("userType")
    };
  },
  beforeMount() {
    this.getCategory();
  },
  computed: {
    appLogin() {
      return store.state.isLoggedIn;
    },
    isTypeSeller() {
      //  if (store.state.isSeller) {
      //     this.userData();
      //   }
      return store.state.isSeller;
    },
  },
  methods: {
    userData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (response.data.data.type == "Seller") {
              if (response.data.data.status == "Pending") {
                this.disableNav = true;
              } else {
                this.disableNav = false;
              }
            } else {
              this.disableNav = true;
            }
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },

    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/category/getlist",
      }).then((response) => {
        this.navItems = response.data.data;
      });
    },
  },
};
</script>